import React from "react";
import { useTranslation } from "../contexts/TranslationContext";
import "../style/component/DonationsTable.css";

function DonationsTable({ projects = [], headerTexts = [] }) {
  const { currentLanguage } = useTranslation();
  const linkText = currentLanguage === "en" ? "Link" : "Liên kết";

  return (
    <section className="donations-table-wrapper">
      <table className="donations-table rounded">
        <thead>
          <tr>
            {headerTexts.map((header, index) => (
              <th key={index} scope="col">
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {projects.map((project, index) => (
            <tr key={project.id || index}>
              <td>{index + 1}</td>
              <td>{project.fileName}</td>
              <td>{project.compilationDate}</td>
              <td>{project.releaseDate}</td>
              <td>
                {project.link ? (
                  <a href={project.link} target="_blank" rel="noopener noreferrer">
                    {linkText}
                  </a>
                ) : (
                  linkText
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}

export default DonationsTable;
